<template>
  <div class="op-login_wrap">
    <!-- <header-bar></header-bar> -->
    <div class="login-main">
      <div class="login-card_wrap">
        <div class="card-header">
          {{ project.name ? project.name : "月兔调查" }}
        </div>
        <el-form ref="op-form" class="op-form" :rules="rules" :model="loginForm">
          <el-form-item prop="project_id" v-if="!$route.query.project_id">
            <el-input v-model="loginForm.project_id" placeholder="请输入项目编号">
              <i slot="prepend" class="el-icon-s-check"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入账号">
              <i slot="prepend" class="el-icon-user-solid"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" placeholder="请输入密码" type="password" show-password>
              <i slot="prepend" class="el-icon-s-goods"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="op-login_btn" :loading="loading" @click="login">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { loginByPwd, getProject } from "@/api/street";
import { setCookies, getCookies } from "@/util/auth";
export default {
  data() {
    return {
      loading: false,
      loginForm: {
        project_id: this.$route.query.project_id || "",
        // grant_type: "password",
        // client_id: 2,
        // client_secret: "LNtSMld9qcQ84UMzd7m5apsVuZZIr33ipc5ujgQn",
        username: "",
        password: "",
        // scope: "",
      },
      project: {
        id: "",
        name: "",
      },
      rules: {
        project_id: [
          {
            required: true,
            message: "请输入项目编号",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // 如果已经登录过，则直接进入 任务列表
    if (getCookies("Access-Token") && getCookies("Token-Type") === "street") {
      this.$router.push({
        name: "street-task-list",
      });
    }

    if (this.$route.query.project_id) {
      this.queryProject();
    }
  },
  methods: {
    async login() {
      const valid = await this.validate();
      if (!valid) return;
      this.loading = true;

      loginByPwd(this.loginForm)
        .then((res) => {
          setCookies("Access-Token", res.token);
          setCookies("Token-Type", "street");
          this.$store.commit("SET_PROJECTDATA", res.project);
          this.$store.commit("SET_GROUP", res.group);
          this.$message({
            type: "success",
            message: "登录成功",
            duration: 1000,
            center: true,
          });
          setTimeout(() => {
            this.$router.push({
              name: "street-task-list",
            });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "登录失败",
            duration: 1500,
            center: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 表单验证
    validate() {
      return new Promise((resolve) => {
        this.$refs["op-form"].validate((valid) => {
          resolve(valid);
        });
      });
    },

    // 获取项目信息
    queryProject() {
      getProject(this.loginForm.project_id).then((res) => {
        this.project = res.data;
      });
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.op-login_wrap {
  .login-main {
    position: relative;
    height: calc(100vh - 65px);
  }

  .login-card_wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 504px;
    height: 360px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .card-header {
    font-size: 24px;
    padding: 10px 0;
    color: #333;
    text-align: center;
    border-bottom: 1px solid #e8e8e8;
  }

  .op-form {
    padding: 30px;
  }

  .op-login_btn {
    width: 100%;
    margin-top: 25px;
  }
}
</style>
